import { Link } from 'react-router-dom';
import { Handshake, TrendingUp, ArrowRight, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';

export default function VendorBand() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-xs uppercase tracking-[0.28em] text-fx-gold font-semibold">The Foxstone Advantage</p>
          <h2 className="font-display text-4xl lg:text-5xl text-fx-navy font-bold mt-3">Built for business owners & vendors alike</h2>
          <div className="fx-section-divider mx-auto mt-5" />
          <p className="mt-5 text-slate-600">Whether you are sourcing equipment for your business or looking to close more sales as a vendor, our programs are designed to deliver.</p>
        </div>

        <Tabs defaultValue="lease" className="mt-12">
          <TabsList className="mx-auto flex max-w-md bg-[#faf7f0] h-12 p-1 border border-[#c9a14a]/30">
            <TabsTrigger value="lease" className="flex-1 text-[#0a2540]/75 data-[state=active]:bg-[#0a2540] data-[state=active]:text-white font-semibold h-10 transition-colors">Leasing</TabsTrigger>
            <TabsTrigger value="vendor" className="flex-1 text-[#0a2540]/75 data-[state=active]:bg-[#0a2540] data-[state=active]:text-white font-semibold h-10 transition-colors">Vendor Program</TabsTrigger>
          </TabsList>

          <TabsContent value="lease" className="mt-10">
            <Card
              icon={<Handshake className="w-7 h-7" />}
              title="Leasing"
              body="Foxstone leases almost all types of new and used equipment assets. Our approach is flexible, focused on providing lease financing across a wide spectrum of equipment classes with terms tailored to each industry we serve."
              points={[
                'Custom payment structures aligned to seasonal cashflow',
                'New and used equipment across all asset classes',
                'Lease-to-own, FMV, and sale-leaseback options',
              ]}
              cta={{ label: 'Explore Leasing', href: '/equipment-leasing' }}
              image="https://images.unsplash.com/photo-1652396669401-db1bc4c4457d?w=1000&q=80"
            />
          </TabsContent>
          <TabsContent value="vendor" className="mt-10">
            <Card
              icon={<TrendingUp className="w-7 h-7" />}
              title="Vendor"
              body="We can help you close more sales while meeting your customers' financing needs. Our vendor programs are innovative, flexible and designed for almost every type of equipment required across industries."
              points={[
                'Co-branded financing solutions for your customers',
                'Same-day pre-approvals to accelerate quotes',
                'Dedicated vendor manager and marketing support',
              ]}
              cta={{ label: 'Become a Vendor Partner', href: '/contact' }}
              image="https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=1000&q=80"
            />
          </TabsContent>
        </Tabs>
      </div>
    </section>
  );
}

function Card({ icon, title, body, points, cta, image }) {
  return (
    <div className="grid lg:grid-cols-2 rounded-lg overflow-hidden border border-slate-200 bg-white fx-lift">
      <div className="relative h-72 lg:h-auto">
        <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-tr from-fx-navy/80 to-transparent" />
      </div>
      <div className="p-10">
        <div className="w-14 h-14 rounded-md bg-fx-cream border border-fx-gold/40 flex items-center justify-center text-fx-gold">{icon}</div>
        <h3 className="font-display text-3xl text-fx-navy font-bold mt-5">{title}</h3>
        <p className="mt-3 text-slate-700 leading-relaxed">{body}</p>
        <ul className="mt-5 space-y-2.5">
          {points.map((p, i) => (
            <li key={i} className="flex gap-3 text-slate-700"><CheckCircle2 className="w-5 h-5 text-fx-gold shrink-0 mt-0.5" /><span>{p}</span></li>
          ))}
        </ul>
        <Button asChild className="mt-7 bg-fx-navy hover:bg-fx-navy-deep text-white rounded-sm h-11 px-6">
          <Link to={cta.href}>{cta.label} <ArrowRight className="w-4 h-4 ml-2" /></Link>
        </Button>
      </div>
    </div>
  );
}
